/**
 * 验证手机号
 */
export const phoneRegular = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

/**
 * 身份证号码为18位，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 */ 
export const idNoRegular = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

/**
 * 身份证最后6位
 */ 
export const idNoLast6BitsRegular = /(^\d{5}(\d|X|x)$)/;

/**
 * 验证邮箱
 */
export const emailRegular = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

/**
 * 验证移动和固定电话
 */
export const contactPhoneRegExp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;

/**
 * 验证经纬度
 */
export const LngAndLatRegExp = /^\d{1,}\.\d{1,}$/;

/**
 * 匹配中英文
 */
export const chEnRegExp = /^\S[\u4e00-\u9fa5a-zA-Z\s]*\S$/;

/**
 * 匹配中文
 */
export const chRegExp = /^[\u4e00-\u9fa5]+$/;

/**
 * 匹配数字
 */
export const numRegExp = /^[1-9]\d*$/;

/**
 * 匹配整数
 */
export const integerRegExp = /^([1-9]\d*|0)(\.\d*[1-9])?$/

/**
 * 匹配空格
 */
export const blankRegExp = /\s+/
/* 
限制英文数字特殊字符
*/
export const strEnRegExp = /^[a-zA-Z0-9+`~!@#$^*()-\\./?,<>;:'{}|\[\]&]+$/
/* 
限制特殊字符与中英数字
*/
export const strRegExp = /^[\u4e00-\u9fa5a-zA-Z0-9+`~!@#$^*()-\\./?,<>;:'{}|\[\]&【】「」。：；“”‘？、《》，！￥%……——（）=•]+$/

/* 
匹配限制特殊符号emoji，忽略大小写
*/
export const emojiExp = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]*|[0-9|*|#](\uFE0F*)\u20E3|[\u203C-\u3299]\uFE0F(\u200D*)|[\u2000-\u2fff]|\u303D|[\u00A9|\u00AE](\u3030*)|\u3030/i

/**
 * img转base64
 * outputFormat eg:'image/png'
 * convertImgToBase64('http://bit.ly/18g0VNp', callback, outputFormat);
 */
export const convertImgToBase64 = (url, callback, outputFormat) => {
    var canvas = document.createElement('CANVAS'),
    ctx = canvas.getContext('2d'),
    img = new Image;
    img.src = url;
    img.setAttribute("crossOrigin",'Anonymous')
    img.onload = function(){
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img,0,0);
        var dataURL = canvas.toDataURL(outputFormat || 'image/png');
        callback(dataURL);
        canvas = null;
    };
}


// WEBPACK FOOTER //
// ./src/utils/regular.js